/**
 * Keyboard shortcuts on the KYC page (computer only — phones have no keys).
 * A letter key works when the customer isn't typing in a box and no window
 * (crop, photo view, dropdown) is open.
 */
export const typing = (t: EventTarget | null) => {
  const el = t as HTMLElement | null;
  return !!el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || el.isContentEditable);
};

export const windowOpen = () => !!document.querySelector('[role="dialog"]');

/** The plain key `key` (no Ctrl / ⌘ / Alt), pressed outside a text box with no window open. */
export const plainKey = (e: KeyboardEvent, key: string) =>
  !e.metaKey && !e.ctrlKey && !e.altKey && e.key.toLowerCase() === key && !typing(e.target) && !windowOpen();

export const SHORTCUTS: Array<[string, string]> = [
  ['Enter', 'Continue / Next box / Submit'],
  ['Esc', 'Back (or leave the box you are typing in)'],
  ['F', 'Add the front photo'],
  ['B', 'Add the back photo'],
  ['O', 'Switch between Aadhaar and another ID'],
  ['A', 'Use this receiver for all boxes'],
  ['R', 'Rotate the photo (in the crop window)'],
  ['?', 'Show or hide this list'],
];
